export default function overviewParallax() {
  // If the browser supports scroll-driven animations, CSS handles it.
  if (
    typeof CSS !== 'undefined' &&
    CSS.supports &&
    (CSS.supports('animation-timeline: view()') || CSS.supports('animation-timeline: scroll()'))
  ) {
    return;
  }

  const words = Array.from(
    document.querySelectorAll('.rotated-heading--parallax .rotated-heading-word')
  );
  if (!words.length) return;

  const parsePx = (val, fallback) => {
    if (!val) return fallback;
    const s = String(val).trim();
    const n = Number.parseFloat(s);
    if (Number.isNaN(n)) return fallback;
    // We treat non-px values as px-equivalent (good enough for this use).
    return n;
  };

  let raf = 0;

  const update = () => {
    raf = 0;
    const vh = window.innerHeight || 1;

    for (const el of words) {
      const rect = el.getBoundingClientRect();

      // Progress 0..1 as element moves through viewport (tweakable via CSS vars)
      const start = vh; // when element enters bottom
      const end = -rect.height; // when element leaves top
      const t = (start - rect.top) / (start - end);
      const progress = Math.max(0, Math.min(1, t));

      const cs = getComputedStyle(el);
      const from = parsePx(cs.getPropertyValue('--parallax-from'), -20);
      const to = parsePx(cs.getPropertyValue('--parallax-to'), 20);
      const speed = parsePx(cs.getPropertyValue('--parallax-speed'), 1);

      const offset = (from + (to - from) * progress) * speed;
      el.style.setProperty('--rotated-parallax', `${offset}px`);
    }
  };

  const schedule = () => {
    if (raf) return;
    raf = window.requestAnimationFrame(update);
  };

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  schedule();
}
